import { Navigate } from "react-router-dom";
import { useAuthStore } from "../stores";
import { Result } from "../components/common";

interface PermissionRouteProps {
  children: React.ReactNode;
  permissions: string[];
  requireAll?: boolean; // Si es true, requiere todos los permisos. Si es false, requiere al menos uno
}

/**
 * Guard que protege rutas basándose en permisos específicos
 * Requiere que el usuario esté autenticado Y tenga los permisos necesarios
 */
export function PermissionRoute({
  children,
  permissions,
  requireAll = false,
}: PermissionRouteProps) {
  const { isAuthenticated, isLoading, hasPermission, hasAnyPermission, hasAllPermissions } =
    useAuthStore();

  if (isLoading) {
    return <div>Cargando...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Validar permisos
  const hasRequiredPermissions = requireAll
    ? hasAllPermissions(permissions)
    : hasAnyPermission(permissions);

  if (!hasRequiredPermissions) {
    // Mostrar pantalla de acceso denegado en lugar de redirigir
    return <Result type="403" />;
  }

  return <>{children}</>;
}
